var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48px",
    height: "px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,52.156863%,95.686275%)",
      fillOpacity: 1
    },
    d: "M 47.488281 24.539062 C 47.488281 22.960938 47.351562 21.460938 47.109375 20 L 24.511719 20 L 24.511719 29.019531 L 37.449219 29.019531 C 36.875 31.953125 35.144531 34.535156 32.648438 36.179688 L 32.648438 42.179688 L 40.371094 42.179688 C 44.890625 38 47.488281 31.839844 47.488281 24.539062 Z M 47.488281 24.539062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.392157%,65.882353%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 24.511719 48 C 30.988281 48 36.410156 45.839844 40.371094 42.179688 L 32.648438 36.179688 C 30.488281 37.621094 27.75 38.5 24.511719 38.5 C 18.25 38.5 12.949219 34.28125 11.050781 28.578125 L 3.089844 28.578125 L 3.089844 34.761719 C 7.03125 42.601562 15.128906 48 24.511719 48 Z M 24.511719 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,73.72549%,1.960784%)",
      fillOpacity: 1
    },
    d: "M 11.050781 28.578125 C 10.550781 27.140625 10.289062 25.601562 10.289062 24 C 10.289062 22.398438 10.570312 20.859375 11.050781 19.421875 L 11.050781 13.238281 L 3.089844 13.238281 C -0.351562 20 -0.351562 28 3.089844 34.761719 Z M 11.050781 28.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(91.764706%,26.27451%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 24.511719 9.5 C 28.050781 9.5 31.210938 10.71875 33.710938 13.101562 L 40.550781 6.261719 C 36.410156 2.378906 30.988281 0 24.511719 0 C 15.128906 0 7.03125 5.398438 3.089844 13.238281 L 11.050781 19.421875 C 12.949219 13.71875 18.25 9.5 24.511719 9.5 Z M 24.511719 9.5 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.9b5ef970.svg";
export { ForwardRef as ReactComponent };